import { CheckableFieldContext } from "./chunk-EYE6MH2Q.js";
import { ValidationIcon_default } from "./chunk-OKKCDA6J.js";
import { ValidationMessage_default } from "./chunk-NN6I72OB.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableField/CheckableField.Validation.tsx
import React, { useContext } from "react";
import clsx from "clsx";
var CheckableFieldValidation = _a => {
  var _b = _a,
    {
      role = "alert",
      className
    } = _b,
    rest = __objRest(_b, ["role", "className"]);
  const {
    id,
    validation,
    validationMessage
  } = useContext(CheckableFieldContext);
  if (!validation) {
    return null;
  }
  return /* @__PURE__ */React.createElement("div", __spreadProps(__spreadValues({}, rest), {
    className: clsx("pd-checkable-field__validation", className)
  }), /* @__PURE__ */React.createElement(ValidationIcon_default, {
    variant: validation,
    className: "pd-checkable-field__validation-icon"
  }), /* @__PURE__ */React.createElement(ValidationMessage_default, {
    variant: validation,
    role,
    id: "".concat(id, "-validation-message"),
    className: "pd-checkable-field__validation-message"
  }, validationMessage));
};
var CheckableField_Validation_default = CheckableFieldValidation;
export { CheckableField_Validation_default };